<template>
  <section>
    <v-container fluid>
      <v-row class="justify-end align-center">
        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <v-data-table
        :headers="headers"
        :items="breaks"
        :search="search"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:item.user.name="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.user.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.user.email"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar size="40" tile>
                <v-avatar
                  size="40"
                  :color="
                    $vuetify.theme.dark
                      ? 'blue-grey darken-4'
                      : 'blue-grey lighten-5'
                  "
                >
                  <v-img
                    v-if="item.url_image"
                    :src="item.url_image"
                    alt="Avatar del usuario"
                  ></v-img>
                  <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.user.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.user.email"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip
            @click="changeStatus(item)"
            outlined
            :color="item.status ? 'success' : 'error'"
            dark
            >{{ item.status ? "Habilitado" : "Inactivo" }}</v-chip
          >
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip color="blue-grey" top>
            <template v-slot:activator="{ on }">
              <v-hover v-slot:default="{ hover }">
                <v-btn
                  v-on="on"
                  text
                  icon
                  :color="hover ? 'error' : 'blue-grey'"
                  @click.stop="UnlockAgent(item)"
                >
                  <v-icon>mdi-lock-open-variant</v-icon>
                </v-btn>
              </v-hover>
            </template>
            <span>Desbloquear agente</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <!-- <v-row justify="end">
            <v-col cols="auto">
                <v-pagination
                    circle
                    color="primary"
                    v-model="page"
                    :length="pageCount"
                ></v-pagination>
            </v-col>
        </v-row> -->

    <v-dialog v-model="showComment" persistent scrollable max-width="500">
      <v-card>
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Añadir comentario
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 350px">
            <v-form>
              <v-row dense>
                <v-col cols="12">
                  <v-textarea
                    filled
                    rounded
                    class="rounded-small"
                    dense
                    name="comment"
                    label="Comentario"
                    v-model="comment"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="showComment = false"
              >Cancelar</v-btn
            >
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="loading"
              :disabled="loading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="unlockConfirm"
              >Continuar</v-btn
            >
          </v-hover>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import vuescroll from "vuescroll";

export default {
  components: {
    vuescroll,
  },

  data() {
    return {
      expanded: [],
      singleExpand: false,
      search: "",
      headers: [
        {
          text: "Agente",
          value: "user.name",
          class: "primary--text",
          width: "30%",
        },
        {
          text: "Nombre pausa",
          value: "pause.name",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Tiempo",
          value: "pause.time",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Tiempo Transcurrido",
          value: "timeOut",
          class: "primary--text",
          width: "20%",
        },
        // {
        //     text: "Correo agente",
        //     value: "user.email",
        //     class: "primary--text",
        //     width: "15%"
        // },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      Agent: {},
      comment: "",
      showComment: false,
    };
  },
  async created() {
    await this.getBreaks();
  },
  computed: {
    breaks() {
      return this.$store.getters["breaks/GET_BREAK_LOCK"];
    },
  },
  methods: {
    async getBreaks() {
      try {
        const response = await this.$store.dispatch(
          "breaks/SHOW_AGENTS_BREAKS_LOCK"
        );
        // console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
    UnlockAgent(item) {
      this.showComment = true;
      this.Agent = item;
    },
    async unlockConfirm() {
      const enviar = {
        comment: {
          comment: this.comment,
        },
        id: this.Agent.id,
      };
      const response = await this.$store.dispatch(
        "breaks/UNLOCK_AGENTS",
        enviar
      );
      this.showComment = false;
      alert(response.data.message);
    },
  },
};
</script>

<style></style>
